<template>
<div class="chapter">
<div class="inner_page">
<p class="center titletop"><span class="textStyle1">Plutarco Elías Calles and the Mexican Revolution</span></p>
<p class="center top1"><span class="textStyle2">Jürgen Buchenau</span></p>
<p class="center top2"><span class="textStyle3">ROWMAN &amp; LITTLEFIELD PUBLISHERS, INC.</span></p>
<p class="center"><span class="textStyle4">Lanham • Boulder • New York • Toronto • Plymouth, UK</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TitlePage.vue?27c1b0d7